import { render, staticRenderFns } from "./Forma49.vue?vue&type=template&id=c1ae6c34&scoped=true&"
import script from "./Forma49.vue?vue&type=script&lang=js&"
export * from "./Forma49.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ae6c34",
  null
  
)

export default component.exports